import script from "./ODadosProjeto.vue?vue&type=script&lang=ts&setup=true"
export * from "./ODadosProjeto.vue?vue&type=script&lang=ts&setup=true"

import "./ODadosProjeto.vue?vue&type=style&index=0&id=92167f32&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92167f32"]])

export default __exports__